<template>
  <div v-for="section in sections" v-bind:key="section.key">
    <div
        v-if="section.key === SECTIONS_KEYS.Location"
    >
      <v-skeleton-loader type="heading" height="100px"></v-skeleton-loader>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.AdvertiserType"
    >
      <v-skeleton-loader type="subtitle" class="mr-16" width="70%"></v-skeleton-loader>

      <div class="d-flex flex-column align-start">
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.Category"
    >
      <div>
        <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.PurchaseMode"
    >
      <v-skeleton-loader type="subtitle" class="mr-16" width="70%"></v-skeleton-loader>

      <div class="d-flex flex-column align-start">
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.VehicleType"
    >
      <v-skeleton-loader type="subtitle" class="mr-16" width="70%"></v-skeleton-loader>

      <div class="d-flex flex-column align-start">
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.VehicleCondition"
    >
      <v-skeleton-loader type="subtitle" class="mr-16" width="70%"></v-skeleton-loader>

      <div class="d-flex flex-column align-start">
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.Report"
    >
      <v-skeleton-loader type="subtitle" class="mr-16" width="70%"></v-skeleton-loader>

      <div class="d-flex flex-column align-start">
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.Opcional"
    >
      <v-skeleton-loader type="subtitle" class="mr-16" width="70%"></v-skeleton-loader>

      <div class="d-flex flex-column align-start">
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.Fuel"
    >
      <v-skeleton-loader type="subtitle" class="mr-16" width="70%"></v-skeleton-loader>

      <div class="d-flex flex-column align-start">
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.Transmission"
    >
      <v-skeleton-loader type="subtitle" class="mr-16" width="70%"></v-skeleton-loader>
      <div class="d-flex flex-column align-start">
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.Fipe"
    >
      <v-skeleton-loader type="heading" class="mb-2"></v-skeleton-loader>
      <div class="d-flex justify-center">
        <v-skeleton-loader type="button" width="200" class="justify-center"></v-skeleton-loader>
        <v-skeleton-loader type="button" width="200" class="justify-center"></v-skeleton-loader>
      </div>
    </div>

    <div
        class="my-5 text-right"
        v-if="section.key === SECTIONS_KEYS.VehicleBranding"
    >
      <v-skeleton-loader type="subtitle" class="justify-start"></v-skeleton-loader>
      <div class="d-flex justify-center">
        <v-skeleton-loader
            v-for="n in 3"
            :key="n"
            type="avatar"
            width="100"
            height="100"
            class="mx-5"
        />
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.VehiclePrice"
    >
      <div>
        <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
        <div class="d-flex justify-center">
          <v-skeleton-loader type="text" width="150" height="32" class="mr-4"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="150" height="32"></v-skeleton-loader>
        </div>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.VehicleYear"
    >
      <div>
        <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
        <div class="d-flex justify-center">
          <v-skeleton-loader type="text" width="150" height="32" class="mr-4"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="150" height="32"></v-skeleton-loader>
        </div>
      </div>
    </div>

    <div
        class="my-5"
        v-if="section.key === SECTIONS_KEYS.VehicleKM"
    >
      <div>
        <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
        <div class="d-flex justify-center">
          <v-skeleton-loader type="text" width="150" height="32" class="mr-4"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="150" height="32"></v-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SECTIONS_KEYS from "@/constants/SectionsKeys";
import {VSkeletonLoader} from "vuetify/components";

export default {
  name: "FilterSidebarSkeleton",
  components: {VSkeletonLoader},
  data: function () {
    return {
      SECTIONS_KEYS,
    };
  },
  props: {
    sections: {
      required: true,
      type: Array
    },
  },
};
</script>
